export const CLIENT_TYPE = 1;
export const CLIENT_SECRET = '';
export const APP_VERSION = '0.0.2.56';
export const COMMIT = '2bbc63488ab5c545f8dcd4a70dbc7e266be6cd22';
export const BRANCH = 'proton-docs@0.0.2.56';
export const DATE_VERSION = 'Thu, 27 Feb 2025 15:14:08 GMT';
export const APP_NAME = 'proton-docs';
export const API_URL =  '/api';
export const SSO_URL = '';
export const LOCALES = {"en_US":"English","de_DE":"Deutsch","fr_FR":"Français","nl_NL":"Nederlands","es_ES":"Español (España)","es_LA":"Español (Latinoamérica)","it_IT":"Italiano","pl_PL":"Polski","pt_BR":"Português (Brasil)","ru_RU":"Русский","tr_TR":"Türkçe","id_ID":"Bahasa Indonesia","ca_ES":"Català","da_DK":"Dansk","sk_SK":"Slovenčina","sl_SI":"Slovenščina","fi_FI":"Suomi","sv_SE":"Svenska","cs_CZ":"Čeština","el_GR":"Ελληνικά","be_BY":"Беларуская","uk_UA":"Українська","ka_GE":"Ქართული","ko_KR":"한국어"};
export const VERSION_PATH = '/assets/version.json';
export const SENTRY_DSN = '';
export const SENTRY_DESKTOP_DSN = '';